import { lazy } from 'react'
import { wrapComponentInSuspense } from '../../components/fallback/SuspenseWithNullFallback'

export { HorizontalScroll as default } from '../../components'

export const HorizontalScroll = wrapComponentInSuspense(
    lazy(() => import('../../components/HorizontalScroll'))
)
